<template>
  <v-sheet elevation="0" width="100%" style="margin-bottom: 1px">
    <div style="font-family: 'Courier New'">
      <b>Ticket #{{index + 1}}</b> - {{ticket.id}}<br>
      -----------------------------------------------------------------------------------------<br>
      Software version: <b>{{ticket.version}}</b><br>
      Specs: <b>{{ticket.specs}}</b><br>
      Connected: <b>{{ticket.connected ? 'Yes' : 'No'}}</b><br>
      Opened by: <b>{{ticket.openedBy}}</b><br>
      Open Date: <b>{{formatTime(ticket.createdAt)}}</b><br>
      Caller's name: <b>{{ticket.callerName}}</b><br>
      Caller's contact Info: <b>{{ticket.callerEmail}}</b><br>
      Tech on site: <b>{{ticket.techOnSite ? 'Yes' : 'No'}}</b><br>
      Demo, New Install, Transferred, or Owned: <b>{{disposition}}</b><br>
      Customer has had unit for: <b>{{ticket.inService}}</b><br>
      Issue description: <b>{{ticket.description}}</b><br>
      Customer was doing: <b>{{ticket.circumstance}}</b><br>
      Issue started on: <b>{{ticket.issueStartedOn}}</b><br>
      Environment: <b>{{ticket.environment}}</b><br>
      Is it currently happening: <b>{{ticket.exhibitingNow ? 'Yes' : 'No'}}</b><br>
      Issue is reproducible: <b>{{ticket.reproducible ? 'Yes': 'No'}}</b><br>
      What steps have been take to resolve the issue: <b>{{ticket.attemptedResolution}}</b><br>
      Components replaced: <b>{{ticket.componentsReplaced}}</b><br>
      Other: <b>{{ticket.other}}</b><br>
      <CommentText
        v-for="(item, index) in ticket.comments"
        :key="item.id"
        :index="index"
        :author="item.authorUsername"
        :time="item.createdAt"
        :text="item.text"
      >
      </CommentText>
      <br>
    </div>
    <!--
    -->
  </v-sheet>
</template>

<script>
import moment from 'moment';
import CommentText from './CommentText.vue';

export default {
  components: {
    CommentText,
  },

  props: {
    index: Number,
    ticket: Object,
  },

  methods: {
    formatTime(time) {
      return moment(time).local().format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>
